import { Typography, Box } from "src/components";
import SubCategories from "../sub-categories"; 
import { useIsMobile } from 'src/hooks';

import backgroundDesktop from "src/assets/placeholders/1200x630.png";
import backgroundMobile from "src/assets/placeholders/600x400.png";

export default function RelatedArticles({ relatedArticles = [] }) {
  const isMobile = useIsMobile();

  if (!relatedArticles.length) return null;

  return (
  <Box
    sx={{
      width: "100%",
      mt: 4,
      position: "relative",
      overflow: "hidden",
      color: "#fff",

      backgroundImage: `url(${isMobile ? backgroundMobile : backgroundDesktop})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",

      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.3)", 
        zIndex: 1,
      },
    }}
  >
    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{ mb: 3 }}
      >
        Related Articles
      </Typography>

      <SubCategories
        articles={relatedArticles.slice(0, 3)}
        categoryColor="primary.main"
      />
    </Box>
  </Box>
  );
}
